import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { pick } from 'lodash';
import { ContactForm } from 'src/app/classes/form-groups/contact-form';
import { SiteForm } from 'src/app/classes/form-groups/site-form';
import { Site } from 'src/app/classes/models';
import { SiteService } from 'src/app/services/site.service';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-add-edit-site-modal',
  templateUrl: './add-edit-site-modal.component.html',
  styleUrl: './add-edit-site-modal.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AddEditSiteModalComponent implements OnInit {
  constructor(
    private activeModal: NgbActiveModal,
    private UtilityService: UtilityService,
    private ToastService: ToastService,
    private SiteService: SiteService,
    private ChangeDetectorRef: ChangeDetectorRef
  ) {
    // Remove mailing address forms from site form as they are not used right now
    this.siteForm.removeControl('MailingAddress');

    // Add siteForm validators
    Object.keys(
      pick(this.siteForm.controls.StreetAddress.getRawValue(), [
        'address1',
        'city',
        'state',
        'zip'
      ])
    ).forEach((key) => {
      this.siteForm.controls.StreetAddress.get(key)?.addValidators([
        Validators.required
      ]);
    });
  }

  @Input() Site?: Site;

  siteForm: SiteForm = new SiteForm();
  einMask = this.UtilityService.einMask;
  phoneMask = this.UtilityService.phoneMask;

  close() {
    this.activeModal.dismiss('Cross Click');
  }

  save() {
    const errors = this.UtilityService.generateValidationErrorsObject(
      this.siteForm
    );

    if (errors) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot save edited site details. Form is missing data.',
        { returnError: true }
      );
    }

    this.SiteService.checkForDuplicateSite(
      this.siteForm.getRawValue()
    ).subscribe({
      next: (duplicateSites: Site[]) => {
        if (duplicateSites && duplicateSites.length > 0) {
          throw this.ToastService.addErrorToast(
            'Error',
            'Cannot save edited details. Found duplicate site info already existing in VIVE.',
            { returnError: true }
          );
        }

        Object.assign(this.Site!, this.siteForm.getRawValue());
        Object.assign(this.Site!, {
          missingRequiredData: false,
          matchingExistingSite: false
        });

        this.activeModal.close(this.siteForm.getRawValue());
      }
    });
  }

  ngOnInit(): void {
    if (!this.Site) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot edit site. No site record found.',
        { returnError: true }
      );
    }

    this.siteForm.patchValue(this.Site);
    this.ChangeDetectorRef.markForCheck();
  }
}
